module.exports = __webpack_public_path__ + "img/star.83f5c612.svg";